import { RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';

const RoomsAssignComponent = lazy(() => import('./rooms-assign.tsx'));

export const roomsAssignRoutes: RouteObject[] = [
  {
    path: '',
    element: (
      <Suspense>
        <RoomsAssignComponent />
      </Suspense>
    )
  }
];
